import { axiosApi as axios } from '../helpers/axiosApi';
import { getCookie } from './helpers';
const GLOSSARY_API = "/studies/glossary/";

export const getAllGlossaryTerms = (params) => {
  return axios.get(GLOSSARY_API, {params: params}).then(res => {
    return res.data;
  });
}

export const addGlossaryTerm = (term) => {
  return axios.post(GLOSSARY_API, term, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => {
    return res.data;
  })
}

export const updateGlossaryTerm = (id, body) => {
  return axios.put(`${GLOSSARY_API}${id}/`, body, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => {
    return res;
  })
}

export const deleteGlossaryTerm = (id) => {
  return axios.delete(`${GLOSSARY_API}${id}/`, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => {
    return res;
  })
}
